import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { CORPORATION, ENV } from "../../../../../config/environment";
import { createOrganization } from "../../../_redux/organization/organizationAction";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import OrganizationCreateForm from "./OrganizationCreateForm";

export default function OrganizationCreate({ history }) {
  const dispatch = useDispatch();

  const { actionsLoading } = useSelector(
    state => state.organizations,
    shallowEqual
  );

  const { user } = useSelector(state => state.auth);

  console.log(user);

  const onSubmit = values => {
    let domainName;
    let regional_uuid;

    if (CORPORATION.toLowerCase() == "simpz") {
      if (ENV.toLowerCase() == "production") {
        domainName = `${values.domain_name}.simpz.id`.toLowerCase();
      } else {
        domainName = `${values.domain_name}.dev.simpz.id`.toLowerCase();
      }
    } else {
      if (ENV.toLowerCase() == "production") {
        domainName = `${values.domain_name}.donorian.com`.toLowerCase();
      } else {
        domainName = `${values.domain_name}.dev.donorian.com`.toLowerCase();
      }
    }
    
    if (user.regional_uuid) {
      regional_uuid = user.regional_uuid;
    } else {
      regional_uuid = values.regional_uuid;
    }

    dispatch(
      createOrganization({
        ...values,
        regional_uuid,
        domain_name: domainName
      })
    )
      .then(res => {
        if (res.error == 400) {
          toast.error(res.message, toastOption);
        } else {
          toast.success(res.data.message, toastOption);
          history.push("/admin/organization");
        }
      })
      .catch(err => {
        toast.error(err);
      });
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader title="Tambah Lembaga">
          <CardHeaderToolbar>
            <button
              className="btn btn-secondary"
              onClick={() => history.goBack()}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <OrganizationCreateForm onSubmit={onSubmit} />
        </CardBody>
      </Card>
    </>
  );
}
